class VariantNumberPicker extends HTMLElement {
  constructor() {
    super();
    this.numberInput = this.querySelector('[data-number-input]');
    this.errorMessage = this.querySelector('[data-error-message]');
    this.min = parseInt(this.dataset.min);
    this.max = parseInt(this.dataset.max);
    this.variantOptions = Array.from(this.querySelectorAll('[data-variant-option]')).sort(
      (a, b) => {
        return parseInt(a.value) - parseInt(b.value);
      }
    );
    this.currentVariantOption = this.variantOptions.find((option) => option.checked);

    this.numberInput.addEventListener('input', this.onNumberInput.bind(this));
    this.numberInput.addEventListener('change', this.onNumberChange.bind(this));
  }

  isOutOfRange(value) {
    return value < this.min || value > this.max;
  }

  onNumberInput(event) {
    const value = parseInt(event.target.value);

    if (this.isOutOfRange(value)) {
      this.displayError();
    } else {
      this.clearError();
    }
  }

  onNumberChange(event) {
    let valueToUse = parseInt(event.target.value);
    const hadRangeError = this.isOutOfRange(valueToUse);

    this.numberInput.value = valueToUse;

    if (hadRangeError) {
      this.displayError();
    } else {
      this.clearError();
    }

    this.findClosestVariantMatch(valueToUse);
  }

  findClosestVariantMatch(value) {
    let closestMatch = null;

    // Find the variant that is larger than the filled in value,
    // but closest to the value. Only use a sorted array of variant
    // options here, otherwise the logic doesn't work.
    for (let i = 0; i < this.variantOptions.length; i++) {
      if (parseInt(this.variantOptions[i].value) < value) {
        continue;
      }
      closestMatch = this.variantOptions[i];
      break;
    }

    if (closestMatch) {
      this.currentVariantOption.checked = false;
      closestMatch.checked = true;
      this.currentVariantOption = closestMatch;
    }
  }

  clearError() {
    if (!this.errorMessage) return;
    this.errorMessage.classList.add('hidden');
    this.errorMessage.setAttribute('aria-hidden', 'true');
  }

  displayError() {
    if (!this.errorMessage) return;
    this.errorMessage.classList.remove('hidden');
    this.errorMessage.setAttribute('aria-hidden', 'false');
  }
}

// Register the unified component
if (!customElements.get('variant-number-picker')) {
  customElements.define('variant-number-picker', VariantNumberPicker);
}
